/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Eventi del dominio TipoPratica per template/canale di comunicazione
 */
export enum EventoTipoPratica {

    PRATICA_SOTTOMESSA = 'PRATICA_SOTTOMESSA',

    OTP_VERIFICA = 'OTP_VERIFICA',

    PRATICA_ACCETTATA = 'PRATICA_ACCETTATA',

    PRATICA_RIFIUTATA = 'PRATICA_RIFIUTATA',

    VOUCHER_EMESSO = 'VOUCHER_EMESSO',

    VOUCHER_PROROGATO = 'VOUCHER_PROROGATO',

    VOUCHER_REVOCATO = 'VOUCHER_REVOCATO',

    VOUCHER_RIATTIVATO = 'VOUCHER_RIATTIVATO',

    GRADUATORIA_CAMBIO_STATO = 'GRADUATORIA_CAMBIO_STATO',

    ESERCENTE_PRATICA_ACCETTATA = 'ESERCENTE_PRATICA_ACCETTATA',

    ESERCENTE_PRATICA_RIACCETTATA = 'ESERCENTE_PRATICA_RIACCETTATA',

    ESERCENTE_PRATICA_RIFIUTATA = 'ESERCENTE_PRATICA_RIFIUTATA',

    ESERCENTE_CONVENZIONE_RIFIUTATA = 'ESERCENTE_CONVENZIONE_RIFIUTATA',

    ESERCENTE_PRATICA_ABILITATA = 'ESERCENTE_PRATICA_ABILITATA',

    ESERCENTE_PRATICA_DISABILITATA = 'ESERCENTE_PRATICA_DISABILITATA',

    ESERCENTE_CONVENZIONE_DA_FIRMARE = 'ESERCENTE_CONVENZIONE_DA_FIRMARE'
}

